import { render } from "./EditPollQuestion.vue?vue&type=template&id=71b8413f"
import script from "./EditPollQuestion.vue?vue&type=script&lang=js"
export * from "./EditPollQuestion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__